import React from 'react';
import ReactDOM from 'react-dom';
import './header.css';

class Header extends React.Component {
  render(){
    return(
    <p>christian<span className='header_blue'>renner</span>.at</p>
   );
  }

}

export default Header;



// WEBPACK FOOTER //
// ./src/header/header.js